


































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { PaymentsModule } from '@/store/modules/payments.module'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import {
  EPaymentStatus,
  ESchedulePaymentCycle,
  ESchedulePaymentSettingStatus,
  EUserPermissions,
  IPayment,
  IPaymentsFiltersDTO
} from '@zunta/configurations'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import { formatTransactionEffectiveDate, getPaidByLabel } from '@/utils/helpers'
import Api from '@/api'
import { User } from '@/classes/User'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import StatusPayment from '@/components/statuses/StatusPayment.vue'
import { PAYMENT_STATUSES_LABEL_MAP } from '@/constants'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'

@Component({
  components: {
    PaymentMethodLabel,
    StatusPayment,
    Table,
    Card,
    DateTimeLabel,
    Icon,
    AddressesPopup
  }
})
export default class PaymentHistory extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  ESchedulePaymentSettingStatus: any = ESchedulePaymentSettingStatus
  ESchedulePaymentCycle: any = ESchedulePaymentCycle
  EUserPermissions: any = EUserPermissions
  EPaymentStatus: any = EPaymentStatus
  user: User = Api.getUser() as User

  formatTransactionEffectiveDate: any = formatTransactionEffectiveDate
  getPaidByLabel: any = getPaidByLabel

  receiptPaymentId: number = -1

  paymentsFilters: IPaymentsFiltersDTO = {
    skip: 0,
    limit: 20
  }

  get isMobile () {
    return window.innerWidth <= 768
  }

  get columns () {
    return {
      id: {
        minWidth: '70px',
        width: 11,
        key: 'id',
        searchKey: 'willowPaymentId',
        hasSearch: true,
        label: 'Id',
        type: ETableColumnType.number
      },
      paidDate: {
        minWidth: '80px',
        width: 15,
        key: 'paidDate',
        searchKey: 'paidDate',
        hasSearch: true,
        hasSort: true,
        label: 'Date',
        type: ETableColumnType.dateRange
      },
      amountPaid: {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '60px',
        width: 18,
        key: 'amountPaid',
        searchKey: 'amountPaid',
        hasSearch: true,
        label: 'Amount',
        type: ETableColumnType.numberRange
      },
      paymentMethod: {
        minWidth: '145px',
        width: 20,
        key: 'paymentMethod',
        searchKey: 'paymentMethod',
        hasSearch: true,
        label: 'Payment Method',
        type: ETableColumnType.default
      },
      processedBy: {
        minWidth: '100px',
        width: 18,
        key: 'processedBy',
        searchKey: 'processedBy',
        hasSearch: true,
        label: 'Processed By',
        type: ETableColumnType.char
      },
      status: {
        minWidth: '110px',
        width: 14,
        key: 'status',
        searchKey: 'status',
        hasSearch: true,
        label: 'Status',
        type: ETableColumnType.select,
        options: this.paymentsStatusesList
      },
      actions: {
        class: 'text-right',
        minWidth: '50px',
        width: 6,
        key: 'actions',
        hasSearch: false
      }
    }
  }

  get desktopColumns () {
    return [
      this.columns.id,
      this.columns.paidDate,
      this.columns.amountPaid,
      this.columns.paymentMethod,
      this.columns.processedBy,
      this.columns.status,
      this.columns.actions,
    ]
  }

  get mobileColumns () {
    return [
      this.columns.paymentMethod,
      this.columns.amountPaid,
      this.columns.paidDate,
      this.columns.status,
      this.columns.actions,
    ]
  }

  get config () {
    const config: ITableConfig = {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      usePagination: true,
      fetchFunction: this.fetchResidentPayments,
      columns: this.isMobile ? this.mobileColumns : this.desktopColumns,
    }

    if (!this.isMobile) {
      return config
    }

    const spareWidth = 100 - config.columns.reduce((acc: number, column: any) => column.width + acc, 0)
    if (spareWidth > 0) {
      const additionalColWidth: number = Number((spareWidth / config.columns.length).toFixed(2))
      config.columns = config.columns.map((column: any) => {
        return {
          ...column,
          width: column.width + additionalColWidth,
          hasSearch: false
        }
      })
    }

    return config
  }

  get residentId () {
    return this.user.getResidents()[0]
  }

  get paymentsTotal () {
    return this.$store.state.payments.total
  }

  get paymentStatusList () {
    return this.$store.state.payments.paymentStatusList
  }

  get paymentsStatusesList () {
    return Object.values(EPaymentStatus)
      .filter((statusValue: EPaymentStatus) => !(this.paymentsFilters.excludeStatuses || []).includes(statusValue))
      .map((status: any) => ({
        value: status,
        content: PAYMENT_STATUSES_LABEL_MAP[status],
        key: status
      }))
  }

  async fetchResidentPayments (filters: any) {
    await this.paymentsModuleInstance.getResidentPaymentsList({
      residentId: this.residentId,
      filters
    })
  }

  showReceipt (payment: IPayment) {
    this.receiptPaymentId = payment.id
  }

  closeReceiptPopup () {
    this.receiptPaymentId = -1
  }
}
